import PriceTag from './priceTag';

export default PriceTag;
